exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-wrapper[data-v-14beafb8]{display:inline-block;padding:20px 20px 4px;background:#e3e3e3;border-radius:15px}.color-wrapper h3[data-v-14beafb8]{font-size:20px;margin-bottom:10px}.color-wrapper p[data-v-14beafb8]{margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14beafb8","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/mortgage/MortgageCalcResult.vue
// module id = OY4u
// module chunks = 0